"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactHelmetAsync = require("react-helmet-async");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PageHeading = _ref => {
  let {
    title,
    ...props
  } = _ref;
  const {
    brand
  } = (0, _reactRedux.useSelector)(state => state.branding);
  const value = _lodash.default.isEmpty(title) ? brand : "".concat(title, " :: ").concat(brand);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, value)), /*#__PURE__*/_react.default.createElement(_material.Typography, _extends({
    children: title
  }, props)));
};
PageHeading.defaultProps = {
  variant: 'h2',
  gutterBottom: true
};
PageHeading.propTypes = {
  title: _propTypes.default.string.isRequired,
  variant: _propTypes.default.string,
  gutterBottom: _propTypes.default.bool
};
var _default = exports.default = PageHeading;